import { Outlet, useNavigation, LoaderFunctionArgs, Link, useRouteLoaderData } from 'react-router';
import LoadingContent from '@/components/common/loading-content';
import { clubApi } from '@repo/api-client';
import { urlControlPanel } from '@/urls';
import { LogOut, Monitor } from 'lucide-react';
import type { Club } from '@repo/shared-types';

function CashierLayout() {
  const navigation = useNavigation();
  const isNavigating = Boolean(navigation.location);
  const { club } = useRouteLoaderData(id) as { club: Club };

  return (
    <div className="flex h-full w-full flex-col bg-neutral-50">
      {/* Minimal header */}
      <div className="flex h-14 w-full items-center justify-between border-b bg-white px-4 shadow-xs shrink-0">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center size-8 rounded-lg bg-primary/10">
            <Monitor className="size-4 text-primary" />
          </div>
          <div className="flex flex-col">
            <span className="text-sm font-bold text-neutral-800 leading-tight">Modo Caja</span>
            <span className="text-xs text-neutral-500 leading-tight">{club.name}</span>
          </div>
        </div>
        <Link
          to={urlControlPanel(club.id)}
          viewTransition
          className="flex items-center gap-2 rounded-lg border border-neutral-200 bg-white px-3 py-2 text-sm font-medium text-neutral-700 transition-colors hover:bg-neutral-50 hover:border-neutral-300"
        >
          <LogOut className="size-4" />
          <span className="hidden sm:inline">Salir</span>
        </Link>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-hidden">
        {isNavigating && <LoadingContent />}
        <Outlet />
      </div>
    </div>
  );
}

const loader = async ({ params }: LoaderFunctionArgs) => {
  const [club, clubs] = await Promise.all([clubApi.getById(params.id as string), clubApi.getAll()]);
  return { club, clubs: clubs.results };
};

export const id = 'cashier-layout';

export const route = {
  id,
  path: '/club/:id/caja',
  element: <CashierLayout />,
  loader,
};
